import { useRecoilValue } from 'recoil'
import { IOption } from '@/types/global.ts'
import { CSSProperties, useMemo } from 'react'
import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import equipmentAtom from '@/pages/Equipment/atoms/equipment.atom.ts'
import SearchDropdownInput from '@/shared/Inputs/SearchDropdownInput'
import equipmentUtils from '@/pages/Equipment/equipment.utils'

interface IProps {
  value: IEquipment['id']
  name: string
  onChange: (val: IEquipment['id'], name: string) => void
  placeholder?: string
  wrapperStyle?: CSSProperties
}

const EquipmentDropdown = (props: IProps) => {
  const equipment = useRecoilValue(equipmentAtom).items

  const options: IOption<IEquipment['id']>[] = useMemo(() => {
    return equipment.map((e) => ({ title: equipmentUtils.getEquipmentAddress(e.location), value: e.id }))
  }, [equipment])

  return (
    <SearchDropdownInput
      options={options as any}
      selectedOption={props.value as any}
      title={props.placeholder || 'Выберите из списка'}
      onSelect={props.onChange}
      name={props.name}
      wrapperStyle={props.wrapperStyle}
    />
  )
}

export default EquipmentDropdown
